import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable()
export class LoginGuard implements CanLoad {
  constructor(
    private router: Router,
    private authService: AuthService) {
  }

  canLoad(): boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate([environment.loginRedirectUrl]);
      return false;
    } else {
      return true;
    }
  }

}
